import { ProductCardLayout } from "../../types/types";
import { Slot } from "../ProductCardSlot";
import styles from "./Standard.module.scss";
import { sendMonetateEvent } from "@~/utils/sendMonetateEvent";

export const slotNameMap = {
  TOP_LEFT_ACTIONS: "top-left-actions",
  TOP_RIGHT_ACTIONS: "top-right-actions",
  BANNER: "banner",
  IMAGE: "image",
  ACTIONS: "actions",
  DRAWER: "drawer",
  MAIN: "main",
  DETAILS: "details",
  FOOTER: "footer",
};

export const Standard: ProductCardLayout = (props) => {
  const { product, config } = props;
  return (
    <article
      ref={props.eventsRef}
      onClick={() => {
        sendMonetateEvent("productCard.interaction");
      }}
      className={styles["card-container"]}
      data-product-card-layout="Standard"
      data-testid="product-card-layout"
      data-product-id={product?.aliases?.pimProductId}
      id={product?.aliases?.pimProductId} // Needed for wish list scrolling
    >
      <div className={styles["image-container"]} data-image-container>
        <Slot
          slotName={slotNameMap["BANNER"]}
          className={styles["banner-slot"]}
          {...props}
        />
        <Slot
          slotName={slotNameMap["TOP_LEFT_ACTIONS"]}
          className={styles["top-left-actions-slot"]}
          {...props}
        />
        <Slot
          slotName={slotNameMap["TOP_RIGHT_ACTIONS"]}
          className={styles["top-right-actions-slot"]}
          {...props}
        />
        <Slot
          slotName={slotNameMap["IMAGE"]}
          className={styles["image-slot"]}
          {...props}
        />
        <Slot
          slotName={slotNameMap["ACTIONS"]}
          className={styles["actions-slot"]}
          {...props}
        />
        <Slot
          slotName={slotNameMap["DRAWER"]}
          className={styles["drawer-slot"]}
          {...props}
        />
      </div>
      <Slot
        slotName={slotNameMap["MAIN"]}
        className={styles["main-slot"]}
        {...props}
      />
      <Slot
        slotName={slotNameMap["DETAILS"]}
        className={styles["details-slot"]}
        {...props}
        bordered={!config["product-card-layout"].props?.hideDetailsBorder}
      />
      <Slot
        slotName={slotNameMap["FOOTER"]}
        className={styles["footer-slot"]}
        {...props}
      />
    </article>
  );
};
